import { ReactElement } from "react";
import { IIconProps } from "../types";

export default function IconCloud({ color, size }: IIconProps): ReactElement {
  return (
    <svg
      height={size || 32}
      width={size || 32}
      viewBox="0 0 32 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.95129 7.51198C3.07457 7.72459 0 10.7719 0 14.5001C0 18.366 3.3062 21.5 7.38461 21.5H24.6154C28.6938 21.5 32 18.366 32 14.5001C32 10.7719 28.9254 7.72459 25.0486 7.51198C24.1983 3.51208 20.4702 0.5 16 0.5C11.5297 0.5 7.80166 3.51208 6.95129 7.51198Z"
        fill={color || "#509EE3"}
      />
    </svg>
  );
}
